import React, { useCallback, useEffect, useState, lazy } from 'react';
// Cookie helper functions
const setCookie = (name: string, value: string, days: number = 7) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${name}=${value};${expires};path=/`;
};
const getCookie = (name: string) => {
  const cookieName = `${name}=`;
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();
    if (cookie.indexOf(cookieName) === 0) {
      return cookie.substring(cookieName.length, cookie.length);
    }
  }
  return '';
};
export const SpecialOffer = () => {
  const [copiesLeft, setCopiesLeft] = useState(() => {
    // Get stored value from cookies or use default
    const storedCopies = getCookie('copiesLeft');
    return storedCopies ? parseInt(storedCopies) : 374;
  });
  // Memoize the update function to prevent unnecessary re-renders
  const updateCopiesLeft = useCallback(() => {
    setCopiesLeft(prevCount => {
      // Random decrease between 1-3
      const decrease = Math.floor(Math.random() * 3) + 1;
      const newCount = Math.max(prevCount - decrease, 5); // Don't go below 5
      // Store in cookie
      setCookie('copiesLeft', newCount.toString(), 7);
      return newCount;
    });
  }, []);
  useEffect(() => {
    // Only start the countdown after the component is fully mounted
    const timer = setTimeout(() => {
      // Decrease count randomly every 3 seconds
      const interval = setInterval(updateCopiesLeft, 3000);
      return () => clearInterval(interval);
    }, 1000);
    return () => clearTimeout(timer);
  }, [updateCopiesLeft]);
  return <div id="offer" className="py-10 md:py-16 bg-gradient-to-br from-blue-100 via-white to-red-100 relative" data-id="element-226">
      {/* Stars background */}
      <div className="absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none" data-id="element-227">
        <div className="w-full h-full bg-repeat" style={{
        backgroundImage: "url('https://www.transparenttextures.com/patterns/stars.png')"
      }} data-id="element-228"></div>
      </div>
      <div className="container mx-auto px-3 md:px-4 max-w-7xl relative z-10" data-id="element-229">
        <h2 className="text-xl md:text-3xl font-bold text-gray-900 mb-4 md:mb-8 text-center flex items-center justify-center" data-id="element-230">
          <span className="text-blue-700 mr-2" data-id="element-231">★</span>
          Special American Values Offer
          <span className="text-red-700 ml-2" data-id="element-232">★</span>
        </h2>
        <div className="bg-white p-3 md:p-8 rounded-lg shadow-lg border border-gray-200 mb-8 md:mb-12 relative overflow-hidden" data-id="element-233">
          {/* Patriotic corner ribbon */}
          <div className="absolute top-0 right-0 w-24 h-24 md:w-32 md:h-32 overflow-hidden" data-id="element-234">
            <div className="absolute top-0 right-0 transform translate-x-8 md:translate-x-12 -translate-y-1 md:-translate-y-2 rotate-45 w-28 md:w-40 h-8 md:h-10 bg-red-700 text-white text-xs md:text-sm font-bold flex items-center justify-center shadow-lg border border-white z-20" data-id="element-235">
              AMERICAN MADE
            </div>
          </div>
          {/* Countdown banner */}
          <div className="bg-red-600 text-white text-center py-1.5 md:py-2 px-3 md:px-4 rounded-md mb-4 md:mb-6 shadow-md" data-id="element-236">
            <p className="font-bold text-sm md:text-base" data-id="element-237">
              URGENT: Only{' '}
              <span className="text-yellow-300 text-lg md:text-xl" data-id="element-238">
                {copiesLeft}
              </span>{' '}
              copies left at this price!
            </p>
          </div>
          {/* Mobile-only promo image - 1:1 ratio */}
          <div className="md:hidden mb-6 w-full" data-id="element-239">
            <div className="aspect-square relative rounded-lg overflow-hidden shadow-lg border-2 border-gray-200" data-id="element-240">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kewNtgeKNFGzSrGf4aYc1C/Generated_Image_October_14%2C_2025_-_9_51AM.png" alt="Patriots Bundle - Digital Free Bonus Books" className="w-full h-full object-cover" loading="lazy" fetchpriority="low" decoding="async" data-id="element-241" />
            </div>
          </div>
          {/* Desktop and Mobile layouts */}
          <div className="flex flex-col md:flex-row items-start gap-4 md:gap-8 mb-4 md:mb-8" data-id="element-242">
            {/* Book Image - Only visible on mobile */}
            <div className="md:hidden w-full relative" data-id="element-243">
              <div className="absolute inset-0 rounded-md bg-gradient-to-tr from-red-700/20 via-white/20 to-blue-700/20" data-id="element-244"></div>
              {/* Book Cover with Badge */}
            </div>
            {/* Pricing Cards - Full width on desktop */}
            <div className="w-full" data-id="element-245">
              {/* All pricing options in one row for desktop, column for mobile */}
              <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-4 mb-4 md:mb-6" data-id="element-246">
                {/* Digital Option */}
                <div className="border-2 border-blue-700 rounded-lg p-2 md:p-4 bg-blue-50 shadow-md h-full flex flex-col" data-id="element-247">
                  <h3 className="text-base md:text-xl font-bold text-blue-800 mb-1 md:mb-2" data-id="element-248">
                    Digital Copy
                  </h3>
                  <p className="text-sm md:text-xl line-through text-gray-500" data-id="element-249">
                    $47.97
                  </p>
                  <p className="text-xl md:text-3xl font-bold text-red-700" data-id="element-250">
                    $19.97
                  </p>
                  <p className="text-xs md:text-base text-green-700 font-medium mt-1 md:mt-2" data-id="element-251">
                    Instant Download
                  </p>
                  <div className="mt-2 md:mt-3 bg-yellow-50 border-l-4 border-yellow-400 p-1.5 md:p-3" data-id="element-252">
                    <p className="font-medium text-xs md:text-base text-gray-800" data-id="element-253">
                      Includes 1 FREE Bonus!
                    </p>
                  </div>
                  {/* Mobile-only image */}
                  <div className="md:hidden mt-2 mb-2" data-id="element-254">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8qheVaTYQHz963ArrQ3Zsu/Generated_Image_October_13%2C_2025_-_3_48PM.png" alt="Digital Copy Preview" className="w-full rounded-md shadow-md aspect-square object-cover" width="200" height="200" loading="lazy" fetchpriority="low" decoding="async" data-id="element-255" />
                  </div>
                  <div className="hidden md:block mt-4 mb-4" data-id="element-256">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eZXRNtoDUfWZZukcGHWHNx/Generated_Image_October_13%2C_2025_-_3_48PM.png" alt="Digital Copy Preview" className="w-full rounded-md shadow-md aspect-square object-cover" width="200" height="200" loading="lazy" fetchpriority="low" decoding="async" data-id="element-257" />
                  </div>
                  <a href="https://www.voicesoffreedomusa.com/cart/47787083301107:1" className="mt-auto inline-block w-full bg-blue-700 hover:bg-blue-800 text-white font-bold py-1.5 md:py-3 px-2 md:px-4 rounded-lg text-xs md:text-base text-center transition-colors duration-300 shadow-md" data-id="element-258">
                    Get Digital Copy
                  </a>
                </div>
                {/* Physical Option */}
                <div className="border-2 border-red-700 rounded-lg p-2 md:p-4 bg-red-50 shadow-md relative h-full flex flex-col" data-id="element-259">
                  <h3 className="text-base md:text-xl font-bold text-red-800 mb-1 md:mb-2" data-id="element-260">
                    Paperback
                  </h3>
                  <p className="text-sm md:text-xl line-through text-gray-500" data-id="element-261">
                    $67.97
                  </p>
                  <p className="text-xl md:text-3xl font-bold text-red-700" data-id="element-262">
                    $34.97
                  </p>
                  <p className="text-xs md:text-base text-amber-700 font-medium mt-1 md:mt-2" data-id="element-263">
                    Ships in 14 days
                  </p>
                  <div className="mt-2 md:mt-3 bg-yellow-50 border-l-4 border-yellow-400 p-1.5 md:p-3" data-id="element-264">
                    <p className="font-medium text-xs md:text-base text-gray-800" data-id="element-265">
                      Includes 3 FREE Bonuses!
                    </p>
                  </div>
                  {/* Mobile-only image */}
                  <div className="md:hidden mt-2 mb-2" data-id="element-266">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/t3TcWrWPtFBsknrxk7LqrG/Generated_Image_October_13%2C_2025_-_3_45PM.png" alt="Physical Copy Book" className="w-full rounded-md shadow-md aspect-square object-cover" width="200" height="200" loading="lazy" fetchpriority="low" decoding="async" data-id="element-267" />
                  </div>
                  <div className="hidden md:block mt-4 mb-4" data-id="element-268">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5LwvhC64CtaMmWqLpX3icm/Generated_Image_October_13%2C_2025_-_3_45PM.png" alt="Physical Copy Book" className="w-full rounded-md shadow-md aspect-square object-cover" width="200" height="200" loading="lazy" fetchpriority="low" decoding="async" data-id="element-269" />
                  </div>
                  <a href="https://www.voicesoffreedomusa.com/cart/47787088937203:1" className="mt-auto inline-block w-full bg-red-700 hover:bg-red-800 text-white font-bold py-1.5 md:py-3 px-2 md:px-4 rounded-lg text-xs md:text-base text-center transition-colors duration-300 shadow-md" data-id="element-270">
                    Order Paperback
                  </a>
                </div>
                {/* Premium Hardcover Option */}
                <div className="border-4 border-blue-800 rounded-lg p-2 md:p-4 bg-blue-50 shadow-md relative h-full flex flex-col" data-id="element-271">
                  {/* PREMIUM Badge */}
                  <div className="absolute -top-2 -right-2 md:-top-3 md:-right-3 z-20" data-id="element-272">
                    <div className="bg-red-700 text-white text-[8px] md:text-xs font-bold px-2 md:px-3 py-0.5 md:py-1 rounded-full transform shadow-lg border border-white" data-id="element-273">
                      BEST SELLER
                    </div>
                  </div>
                  <div className="absolute -top-2 -left-2 md:-top-3 md:-left-3 z-20 hidden md:block" data-id="element-274">
                    <div className="bg-blue-800 text-white text-[8px] md:text-xs font-bold px-1.5 md:px-2 py-0.5 md:py-1 rounded-full transform shadow-lg border border-white" data-id="element-275">
                      40% OFF
                    </div>
                  </div>
                  <h3 className="text-base md:text-xl font-bold text-blue-900 mb-1 md:mb-2" data-id="element-276">
                    Premium
                  </h3>
                  <p className="text-sm md:text-xl line-through text-gray-500" data-id="element-277">
                    $127.97
                  </p>
                  <p className="text-xl md:text-3xl font-bold text-red-700" data-id="element-278">
                    $64.97
                  </p>
                  <p className="text-xs md:text-base text-amber-700 font-medium mt-1 md:mt-2" data-id="element-279">
                    Ships in 14 days
                  </p>
                  <div className="mt-2 md:mt-3 bg-yellow-50 border-l-4 border-yellow-400 p-1.5 md:p-3" data-id="element-280">
                    <p className="font-medium text-xs md:text-base text-gray-800" data-id="element-281">
                      Includes 3 FREE Bonuses!
                    </p>
                  </div>
                  {/* Mobile-only image */}
                  <div className="md:hidden mt-2 mb-2" data-id="element-282">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/beUossBSUyLQi36x3f3a6L/Generated_Image_October_13%2C_2025_-_3_27PM_%281%29.png" alt="Premium Hardcover Edition" className="w-full rounded-md shadow-md aspect-square object-cover" width="200" height="200" loading="lazy" fetchpriority="low" decoding="async" data-id="element-283" />
                  </div>
                  <div className="hidden md:block mt-4 mb-4" data-id="element-284">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/w62rAPdWYa8Vy2fdsQUEYo/Generated_Image_October_13%2C_2025_-_3_27PM_%282%29.png" alt="Premium Hardcover Edition" className="w-full rounded-md shadow-md aspect-square object-cover" width="200" height="200" loading="lazy" fetchpriority="low" decoding="async" data-id="element-285" />
                  </div>
                  <a href="https://www.voicesoffreedomusa.com/cart/47787092541683:1" className="mt-auto inline-block w-full bg-blue-800 hover:bg-blue-900 text-white font-bold py-1.5 md:py-3 px-2 md:px-4 rounded-lg text-xs md:text-base text-center transition-colors duration-300 shadow-md" data-id="element-286">
                    Order Premium
                  </a>
                </div>
                {/* Super Bundle - The Patriot Vault */}
                <div className="border-2 border-red-800 rounded-lg p-2 md:p-4 bg-red-50 shadow-lg relative h-full flex flex-col" data-id="element-287">
                  {/* COLLECTOR'S EDITION Badge */}
                  <div className="absolute -top-2 -right-2 md:-top-3 md:-right-3 z-20" data-id="element-288">
                    <div className="bg-red-700 text-white text-[8px] md:text-xs font-bold px-2 md:px-3 py-0.5 md:py-1 rounded-full transform shadow-lg border border-white" data-id="element-289">
                      COLLECTOR'S
                    </div>
                  </div>
                  <h3 className="text-base md:text-xl font-bold text-red-900 mb-1 md:mb-2" data-id="element-290">
                    Super Bundle
                  </h3>
                  <p className="text-sm md:text-xl line-through text-gray-500" data-id="element-291">
                    $419.97
                  </p>
                  <p className="text-xl md:text-3xl font-bold text-red-700" data-id="element-292">
                    $251.37
                  </p>
                  <p className="text-xs md:text-base text-blue-700 font-medium mt-1 md:mt-2" data-id="element-293">
                    Priority Shipping
                  </p>
                  <div className="mt-2 md:mt-3 bg-yellow-50 border-l-4 border-yellow-400 p-1.5 md:p-3" data-id="element-294">
                    <p className="font-medium text-xs md:text-base text-gray-800" data-id="element-295">
                      Includes 3 FREE Bonuses!
                    </p>
                  </div>
                  {/* Mobile-only image */}
                  <div className="md:hidden mt-2 mb-2" data-id="element-296">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/eW9ndHdoX4tsjjvcs3FKWk/Generated_Image_October_13%2C_2025_-_5_15PM.png" alt="The Patriot Vault Collector's Edition" className="w-full rounded-md shadow-md aspect-square object-cover" width="200" height="200" loading="lazy" fetchpriority="low" decoding="async" data-id="element-297" />
                  </div>
                  <div className="hidden md:block mt-4 mb-4" data-id="element-298">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/8gv27SBHqiZARHgmyMGpc5/Generated_Image_October_13%2C_2025_-_5_15PM.png" alt="The Patriot Vault Collector's Edition" className="w-full rounded-md shadow-md aspect-square object-cover" width="200" height="200" loading="lazy" fetchpriority="low" decoding="async" data-id="element-299" />
                  </div>
                  <div className="hidden md:block mt-3 bg-blue-50 border-l-4 border-blue-700 p-3" data-id="element-300">
                    <p className="font-medium text-gray-800" data-id="element-301">
                      5-Item Collection:
                    </p>
                    <ul className="list-disc pl-4 space-y-0.5 text-gray-700 text-sm" data-id="element-302">
                      <li data-id="element-303">Limited Edition Art</li>
                      <li data-id="element-304">Premium Hardcover</li>
                      <li data-id="element-305">FREEDOM™ Mug</li>
                      <li data-id="element-306">Signature T-Shirt</li>
                      <li data-id="element-307">Signature Hat</li>
                    </ul>
                  </div>
                  <a href="https://voicesoffreedomusa.com/products/the-patriot-vault-charlie-kirk-collector-s-edition-2" className="mt-auto inline-block w-full bg-red-800 hover:bg-red-900 text-white font-bold py-1.5 md:py-3 px-2 md:px-4 rounded-lg text-xs md:text-base text-center transition-colors duration-300 shadow-md border border-white" data-id="element-308">
                    Get Collector's
                  </a>
                </div>
              </div>
              <div className="bg-blue-50 border-l-4 border-blue-700 p-2 md:p-4 mb-4 md:mb-6" data-id="element-309">
                <p className="text-sm md:text-lg font-medium" data-id="element-310">
                  But there's a catch: only a limited number of copies are being
                  released at this price for freedom-loving Americans.
                </p>
              </div>
            </div>
          </div>
          <div className="mt-4 md:mt-8 text-center" data-id="element-311">
            <h3 className="text-lg md:text-xl font-bold text-gray-900 mb-2 md:mb-4 flex items-center justify-center" data-id="element-312">
              <span className="text-red-700 mr-2" data-id="element-313">★</span>
              Take action now
              <span className="text-blue-700 ml-2" data-id="element-314">★</span>
            </h3>
            <p className="text-sm md:text-lg text-gray-700 mb-4 md:mb-8" data-id="element-315">
              👉 Click below to claim your copy before this patriotic launch
              discount expires.
            </p>
            <a href="#offer" className="inline-block bg-red-700 hover:bg-red-800 text-white font-bold py-3 md:py-4 px-6 md:px-10 rounded-lg text-base md:text-xl transition-colors duration-300 shadow-md border-2 border-white relative overflow-hidden group" data-id="element-316">
              <span className="relative z-10" data-id="element-317">
                Get My Copy Now – Limited Time Offer
              </span>
              <span className="absolute inset-0 bg-gradient-to-r from-blue-700 to-blue-700 transform scale-x-0 group-hover:scale-x-100 transition-transform origin-left duration-300" data-id="element-318"></span>
            </a>
          </div>
        </div>
      </div>
    </div>;
};